import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { CookieBanner } from "@/components/site/CookieBanner";
import Landing from "@/pages/Landing";
import { AvisoLegal, PoliticaPrivacidad, PoliticaCookies } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <div className="we-noise" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScroll>
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
          </Routes>
          <Footer />
          <CookieBanner />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
